var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoSub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_info_sub_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.67 2.67h39.65v39.65H2.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_info_sub_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.78 13a2.09 2.09 0 01-.67 1.65 2.32 2.32 0 01-1.59.59 2.44 2.44 0 01-1.62-.58 2.09 2.09 0 01-.68-1.66 2.06 2.06 0 01.69-1.59 2.34 2.34 0 011.61-.63 2.37 2.37 0 011.57.57 2 2 0 01.69 1.65m-4.26 6.67a2.53 2.53 0 01.54-1.77 1.84 1.84 0 011.42-.6 1.9 1.9 0 011.44.6 2.32 2.32 0 01.56 1.65V31a2.6 2.6 0 01-.56 1.8 1.87 1.87 0 01-1.44.61 1.83 1.83 0 01-1.42-.62 2.68 2.68 0 01-.54-1.79zm21.81 2.83A19.83 19.83 0 1022.5 42.33 19.83 19.83 0 0042.33 22.5",
    fill: "#c01774"
  }))));
}

export default SvgIconInfoSub;